var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0501 3.76258C25.4117 3.12384 24.6537 2.61714 23.8193 2.27144C22.985 1.92574 22.0908 1.7478 21.1876 1.7478C20.2845 1.7478 19.3903 1.92574 18.556 2.27144C17.7216 2.61714 16.9636 3.12384 16.3251 3.76258L15.0001 5.08758L13.6751 3.76258C12.3855 2.47297 10.6364 1.74847 8.81265 1.74847C6.98886 1.74847 5.23976 2.47297 3.95015 3.76258C2.66053 5.0522 1.93604 6.80129 1.93604 8.62508C1.93604 10.4489 2.66053 12.198 3.95015 13.4876L5.27515 14.8126L15.0001 24.5376L24.7251 14.8126L26.0501 13.4876C26.6889 12.8491 27.1956 12.0911 27.5413 11.2568C27.887 10.4225 28.0649 9.52819 28.0649 8.62508C28.0649 7.72198 27.887 6.82771 27.5413 5.99339C27.1956 5.15907 26.6889 4.40103 26.0501 3.76258Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.5985de7aa049b1f36cd6794c2a02920a.svg";
export { ForwardRef as ReactComponent };